import { consoleLog } from "../consoleLog/consoleLog";

export const parseStringToJson = (jsonString: string) => {
  // First try standard JSON.parse
  try {
    return JSON.parse(jsonString);
  } catch (e: any) {
    consoleLog(["Standard JSON.parse failed:", e?.message]);
    consoleLog("Attempting fallback parsing");

    try {
      // Extract the intent
      const intentMatch = jsonString.match(/"intent":\s*"([^"]+)"/);
      const intent = intentMatch ? intentMatch[1] : null;

      // Extract the statement - handles multiline content
      const statementMatch = jsonString.match(/"statement":\s*"([\s\S]+?)(?:"\s*\}|"\s*,)/);
      let statement = statementMatch ? statementMatch[1] : null;

      return {
        intent: intent,
        statement: statement,
      };
    } catch (e2: any) {
      consoleLog(["Fallback parsing failed:", e2?.message]);
      throw new Error("Could not parse JSON: " + e.message);
    }
  }
};
